import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerLocationProvider } from "@/context/CustomerLocationContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import DriverEarnings from "@/pages/driver/DriverEarnings";
import DriverSchedule from "@/pages/driver/DriverSchedule";
import DriverAccount from "@/pages/driver/DriverAccount";
import DriverTraining from "@/pages/driver/DriverTraining";
import BusyAreas from "@/pages/driver/BusyAreas";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import CustomerHome from "@/pages/customer/CustomerHome";
import CustomerTrips from "@/pages/customer/CustomerTrips";
import DriverHome from "@/pages/driver/DriverHome";
import DriverTrips from "@/pages/driver/DriverTrips";
import AdminHome from "@/pages/admin/AdminHome";
import TripDetailPage from "@/pages/TripDetailPage";
import SupportPage from "@/pages/SupportPage";
import { CustomerPromos, DriverPromos } from "@/pages/PromosPages";
import { AssistantWidget } from "@/components/assistant/AssistantWidget";
import { SetupSuccess, SetupCancel, PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import GetTheApp from "@/pages/GetTheApp";
import DriverTrainingPublic from "@/pages/DriverTrainingPublic";
import TripFeedbackPage from "@/pages/TripFeedbackPage";
import MyRatings from "@/pages/MyRatings";
import AddCardPage from "@/pages/customer/AddCardPage";
import { ReceiptsPage, ReceiptDetailPage } from "@/pages/ReceiptsPage";
import { PrivacyPage, TermsPage, DeleteAccountInfoPage } from "@/pages/LegalPages";
import AccountPage from "@/pages/AccountPage";
import BusinessPortal, { BusinessDeliveryPage } from "@/pages/business/BusinessPortal";
import TrackPage from "@/pages/TrackPage";
import LocalGuide from "@/pages/customer/LocalGuide";
import DriverHub from "@/pages/driver/DriverHub";
import { PayPalReturn } from "@/pages/PaymentPages";

const guard = (roles, el) => <ProtectedRoute roles={roles}>{el}</ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CustomerLocationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/get-the-app" element={<GetTheApp />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/delete-account" element={<DeleteAccountInfoPage />} />
            <Route path="/account" element={<ProtectedRoute roles={["customer", "business", "admin"]} consentExempt><AccountPage /></ProtectedRoute>} />
            <Route path="/driver-training" element={<DriverTrainingPublic />} />
            <Route path="/customer" element={guard(["customer"], <CustomerHome />)} />
            <Route path="/customer/trips" element={guard(["customer"], <CustomerTrips />)} />
            <Route path="/customer/add-card" element={<ProtectedRoute roles={["customer"]} cardSetup><AddCardPage /></ProtectedRoute>} />
            <Route path="/receipts" element={guard(["customer", "admin"], <ReceiptsPage />)} />
            <Route path="/receipts/:id" element={guard(["customer", "admin"], <ReceiptDetailPage />)} />
            <Route path="/driver" element={guard(["driver"], <DriverHome />)} />
            <Route path="/driver/trips" element={guard(["driver"], <DriverTrips />)} />
            <Route path="/driver/earnings" element={guard(["driver"], <DriverEarnings />)} />
            <Route path="/driver/schedule" element={guard(["driver"], <DriverSchedule />)} />
            <Route path="/driver/account" element={guard(["driver"], <DriverAccount />)} />
            <Route path="/driver/training" element={guard(["driver"], <DriverTraining />)} />
            <Route path="/driver/busy-areas" element={guard(["driver"], <BusyAreas />)} />
            <Route path="/admin" element={guard(["admin"], <AdminHome />)} />
            <Route path="/trips/:id" element={guard(null, <TripDetailPage />)} />
            <Route path="/trips/:id/feedback" element={guard(null, <TripFeedbackPage />)} />
            <Route path="/ratings" element={guard(["customer", "driver"], <MyRatings />)} />
            <Route path="/customer/promos" element={guard(["customer"], <CustomerPromos />)} />
            <Route path="/driver/promos" element={guard(["driver"], <DriverPromos />)} />
            <Route path="/driver/hub" element={guard(["driver"], <DriverHub />)} />
            <Route path="/support" element={guard(["customer", "driver", "business"], <SupportPage />)} />
            <Route path="/business" element={guard(["business"], <BusinessPortal />)} />
            <Route path="/business/deliveries/:id" element={guard(["business"], <BusinessDeliveryPage />)} />
            <Route path="/track/:token" element={<TrackPage />} />
            <Route path="/payment/setup-success" element={guard(["customer"], <SetupSuccess />)} />
            <Route path="/payment/setup-cancel" element={guard(["customer"], <SetupCancel />)} />
            <Route path="/payment/success" element={guard(["customer"], <PaymentSuccess />)} />
            <Route path="/payment/cancel" element={guard(["customer"], <PaymentCancel />)} />
            <Route path="/payment/paypal-return" element={guard(["customer"], <PayPalReturn />)} />
            <Route path="/guide" element={guard(["customer"], <LocalGuide />)} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <AssistantWidget />
        </BrowserRouter>
        </CustomerLocationProvider>
        <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#121216", border: "1px solid rgba(212,175,55,0.3)", color: "#f5f3ef" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
